export class FilterControls {
    constructor(eventBus) {
        this.events = {
            filterUpdated: "filterUpdated",
        };
        this.filters = {};
        this.eventBus = eventBus;
        this.initialize();
    }
    initialize() {
        this.bindDomEvents();
        this.updateFiltersFromUrl();
        this.updateFilterControlsText();
    }
    bindDomEvents() {
        document.addEventListener("click", (e) => {
            const target = e.target;
            if (e.target &&
                target.dataset &&
                target.dataset.action &&
                target.dataset.action === "filter") {
                this.updateFiltersFromDataSet(target.dataset);
                this.updateUrl();
                this.updateFilterControlsText();
            }
        });
        window.addEventListener("popstate", () => {
            this.updateFiltersFromUrl();
            this.updateFilterControlsText();
        });
    }
    updateUrl() {
        const urlBase = window.location.protocol +
            "//" +
            window.location.host +
            window.location.pathname;
        let queryString = "?";
        const keys = Object.keys(this.filters);
        keys.forEach((key, index) => {
            queryString +=
                index === 0
                    ? `${key}=${this.filters[key]}`
                    : `&${key}=${this.filters[key]}`;
        });
        history.pushState(null, "", urlBase + queryString);
    }
    updateFiltersFromUrl() {
        this.filters = {};
        const parameters = this.getQueryStringParameters(window.location.href);
        for (const key in parameters) {
            this.filters[key] = parameters[key];
        }
        this.eventBus.publish(this.events.filterUpdated, this.filters);
    }
    updateFiltersFromDataSet(dataSet) {
        Object.keys(dataSet).forEach((key) => {
            if (key !== "action" && key.includes("filter")) {
                const propertyName = this.substringFilterDataAttribute(key).toLowerCase();
                this.filters[propertyName] = dataSet[key];
            }
        });
        this.eventBus.publish(this.events.filterUpdated, this.filters);
    }
    updateFilterControlsText() {
        const parameters = this.getQueryStringParameters(window.location.href);
        for (const key in parameters) {
            const elementToUpdate = document.querySelector(`[data-title-${key}]`);
            const displayValue = elementToUpdate?.dataset?.display ?? parameters[key];
            const title = parameters[key].toLowerCase() === "all" ? displayValue : displayValue;
            if (elementToUpdate) {
                elementToUpdate.innerHTML = `${title}<span class="caret"></span>`;
            }
        }
    }
    substringFilterDataAttribute(key) {
        return key.substring(key.indexOf("filter") + 6);
    }
    getQueryStringParameters(url) {
        const params = {};
        const urlObj = new URL(url);
        urlObj.searchParams.forEach((value, key) => {
            params[key] = value;
        });
        return params;
    }
}
